export function Pnr( language, country ) {
  return `/myb/${language}-${country}/`;
}

export function Iropsatc(language, country) {
  return `/myb/${language}-${country}/self-reaccomm`;
}

export function HomeE4( language, country ) {
  let url = '';
  switch (language) {
    case 'en':
      url = `/${language}-${country}/manage-your-booking/`;
      break;
    case 'es':
      url = `/${language}-${country}/administra-tu-viaje/`;
      break;
    case 'fr':
      url = `/${language}-${country}/gerez-votre-reservation/`;
      break;
    case 'pt':
      url = `/${language}-${country}/gerencie-sua-reserva/`;
      break;
    case 'it':
      url = `/${language}-${country}/gestisci-viaggio/`;
      break;
    case 'jp':
      url = `/${language}-${country}/manage-your-booking/`;
      break;
    default:
      url = '/es-mx/administra-tu-viaje/';
      break;
  }

  return url;
}


export function Home( language, country) {
  let url = '';
  switch (language) {
    case 'en':
      url = `/myb/${language}-${country}/manage-your-booking`;
      break;
    case 'es':
      url = `/myb/${language}-${country}/administra-tu-viaje`;
      break;
    case 'fr':
      url = `/myb/${language}-${country}/gerez-votre-reservation`;
      break;
    case 'pt':
      url = `/myb/${language}-${country}/gerencie-sua-reserva`;
      break;
    case 'it':
      url = `/myb/${language}-${country}/gestisci-viaggio`;
      break;
    case 'jp':
      url = `/myb/${language}-${country}/manage-your-booking`;
      break;
    default:
      url = '/myb/es-mx/administra-tu-viaje';
      break;
  }

  return url;
}

export function CheckInE4( language, country ) {
  let url = '';

  switch ( language ) {
    case 'en':
      url = `${language}-${country}/check-in/flights`;
      break;
    case 'es':
      url = `${language}-${country}/check-in/vuelos`;
      break;
    case 'fr':
      url = `${language}-${country}/enregistrement/vols`;
      break;
    case 'pt':
      url = `${language}-${country}/check-in/voos`;
      break;
    case 'it':
      url = `${language}-${country}/check-in/volo`;
      break;
    case 'jp':
      url = `${language}-${country}/check-in/flights`;
      break;
  }
  
  return url;
}

export function ReservaE4( language, country ) {
  let url = '';

  switch ( language ) {
    case 'en':
      url = `${language}-${country}/book?tripType=Multicity`;
      break;
    case 'es':
      url = `${language}-${country}/reserva?tripType=Multicity`;
      break;
    case 'fr':
      url = `${language}-${country}/reservez?tripType=Multicity`;
      break;
    case 'pt':
      url = `${language}-${country}/reserva?tripType=Multicity`;
      break;
    // it
    case 'it':
      url = `${language}-${country}/prenotazione?tripType=Multicity`;
      break;
    case 'jp':
      url = `${language}-${country}/book?tripType=Multicity`;
      break;
  }
  return url;
}

export function Refund( language, country ) {
  let url = '';

  switch ( language ) {
    case 'en':
      url = `/myb/${language}-${country}/reembolsos`;
      break;
    case 'es':
      url = `/myb/${language}-${country}/reembolsos`;
      break;
    case 'fr':
      url = `/myb/${language}-${country}/reembolsos`;
      break;
    case 'pt':
      url = `/myb/${language}-${country}/reembolsos`;
      break;
  }
  return url;
}

export function Billing( language, country ) {
  let url = '';

  switch ( language ) {
    case 'en':
      url = `/myb/${language}-${country}/facturacion`;
      break;
    case 'es':
      url = `/myb/${language}-${country}/facturacion`;
      break;
    case 'fr':
      url = `/myb/${language}-${country}/facturacion`;
      break;
    case 'pt':
      url = `/myb/${language}-${country}/facturacion`;
      break;
  }
  return url;
}